const INITIAL_STATE = true;

const open_menu = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case 'SET_OPEN_MENU':
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export default open_menu;
